export default __webpack_public_path__ + "static/media/06_ALoveStoryI.02475be0.jpg";